import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { animatedInputFocus, animatedInputBlur, animatedInputPasswordToggle } from 'lib/animated-input';

import Input from 'components/common/input';
import InputPopup from 'components/common/input/popup';
import Eyeball from 'components/svgs/icons/eyeball';


class InputPassword extends React.Component {
  constructor(props) {
    super(props);

    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onToggle = this.onToggle.bind(this);
  }

  onBlur(e) {
    animatedInputBlur(this.props.value);
  }

  onChange(e) {
    this.props.onChange(this.props.value, e)
  }

  onFocus(e) {
    animatedInputFocus(this.props.value);
    if (this.props.error) { this.props.dismissError(this.props.value); }
  }

  onToggle(e) {
    animatedInputPasswordToggle(this.props.value);
  }

  render() {
    const showError = this.props.error && (this.props.showTip ? this.password.value !== '' : true);

    const classNames = cx({
      'animated-input': true,
      'input-error': this.props.error ? true : false
    });

    return(
      <div className={classNames}>
        {
          showError
          ? <InputPopup message={this.props.error} />
          : null
        }
        <Input ref={(input) => { this.password = input; }} type="password" value={this.props.value} onBlur={this.onBlur} onChange={this.onChange} onFocus={this.onFocus}/>
        <label className="h5-sg text-weight-light">
          <span>{this.props.display}</span>
        </label>
        { this.props.showTip ?
          (
            <label className="h6-sg text-weight-light password-requirement">
              <span>must be at least 8 characters</span>
            </label>
          )
          : null
        }
        <label id={`${this.props.value}-show`} className="h6-sg text-weight-light password-show">
          <span id="password-toggle" onClick={this.onToggle}><Eyeball /></span>
        </label>
      </div>
    );
  }
}

InputPassword.propTypes = {
  // Props
  display:  PropTypes.string,
  error:  PropTypes.string,
  value:  PropTypes.string,
  // Functions
  dismissError:  PropTypes.func,
  onChange:  PropTypes.func,
}

export default InputPassword;
